import { useQuery } from "@apollo/client";
import { Button, LinearProgress, Modal, Typography } from "@material-ui/core";
import ConfigForm, {
  ConfigInput,
  FormOption,
} from "components/Layout/ConfigForm";
import StandardModal from "components/Layout/StandardModal";
import { getGoogleMaps } from "config/GoogleMaps";
import { BuildingContext } from "Context/BuildingProvider";
import { AuthContext } from "Firebase/AuthProvider";
import {
  FloorOverlay,
  GetPoisByTypeQueryResult,
  PoiType,
} from "generated/graphql";
import { GET_POIS_BY_TYPE } from "lib/pois";
import React, { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import { getModalStyle, useStyles } from "Theme/styles";

const MapContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;
const ControlContainer = styled.div`
  padding: 12px 0;
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
`;

export interface PoiMapProps {
  poiTypeIds: string[];
  poiTypes?: PoiType[];
  floorOverlays: Pick<
    FloorOverlay,
    | "BuildingId"
    | "CenterLat"
    | "CenterLng"
    | "D_diff"
    | "FloorNumber"
    | "Id"
    | "ImageUrl"
    | "Name"
    | "Rot"
    | "created_at"
    | "k_diff"
    | "updated_at"
    | "AndroidFloors"
  >[];
}
interface PoiMapState {
  currentFloorNumber: number;
  //@ts-ignore
  currentLocation?: { lat: number; lng: number };
  lastPoint: any;
  poisToAdd: any[];
  poisToEdit: any[];
  poisToDelete: any[];
  layerToggle: boolean;
  currentTitle: string;
  idCount: number;
  markerClickedToggle: boolean;
  markerListPosition: number;
  type: string;
}

const DEFAULT_STATE: PoiMapState = {
  currentFloorNumber: 0,
  lastPoint: {},
  poisToAdd: [],
  poisToEdit: [],
  poisToDelete: [],
  layerToggle: false,
  currentTitle: "",
  idCount: 0,
  markerClickedToggle: false,
  markerListPosition: 0,
  type: "",
};
//@ts-ignore
let map: any;
export default function PoiMap(props: PoiMapProps) {
  const [state, setState] = useState(DEFAULT_STATE);
  const { floorOverlays } = props;

  const { currentBuilding, updateBuilding } = useContext(BuildingContext);
  const { getImageUrl } = useContext(AuthContext);
  const { loading, error, data }: GetPoisByTypeQueryResult = useQuery(
    GET_POIS_BY_TYPE,
    {
      variables: {
        buildingId: currentBuilding?.Id,
        poiTypes: props.poiTypeIds,
      },
    }
  );
  var overlay: google.maps.OverlayView;
  //@ts-ignore
  var loc_center: google.maps.LatLng;
  var CenterLat: number;
  var CenterLng: number;
  var k_diff: number = 0.005;
  var D_diff: number = 0.01;
  var rot: number = 0;
  let infowindow;
  let markerList: any[] = [];

  const handlePoiTypeChange = (event: any) => {};

  const markerClicked = (marker: google.maps.Marker) => {
    let markerListPosition;
    markerList.forEach((markerInList, index) => {
      if (markerInList === marker) {
        markerListPosition = index;
      }
    });
    if (!!markerListPosition) {
      setState({
        ...state,
        markerClickedToggle: true,
        layerToggle: true,
        //@ts-ignore
        currentTitle: marker.label.text,
        //@ts-ignore
        lastPoint: marker.position,
        markerListPosition: markerListPosition,
      });
    }
  };

  const markerDragged = (marker: google.maps.Marker) => {
    console.log(
      "🚀 ~ file: PoiMap.tsx ~ line 166 ~ markerDragged ~ marker",
      marker
    );
    let newPoi = {
      //@ts-ignore
      Id: marker.id,
      BuildingId: currentBuilding!.Id,
      //@ts-ignore
      Description: marker.label.text,
      //@ts-ignore
      Lat: marker.position.lat(),
      //@ts-ignore
      Long: marker.position.lng(),
      floorId: floorOverlays[state.currentFloorNumber].AndroidFloors[0].Id,
    };
    let poisToEdit = state.poisToEdit;
    let poisToAdd = state.poisToAdd;
    let poiAdded = false;
    state.poisToAdd.forEach((poi) => {
      if (poi.Id === newPoi.Id) {
        poiAdded = true;
      }
    });
    let poiEdited = false;

    state.poisToEdit.forEach((poi) => {
      if (poi.Id === newPoi.Id) {
        poiEdited = true;
      }
    });
    if (poiAdded) {
      //logic to update poi to add
      poisToAdd = poisToAdd.filter((poi) => {
        return poi.Id !== newPoi.Id;
      });
      poisToAdd.push(newPoi);
      setState({
        ...state,
        layerToggle: false,
        poisToAdd: poisToAdd,
        markerClickedToggle: false,
        currentTitle: "",
      });
    }
    if (poiEdited) {
      //logic to update poi to edit
      poisToEdit = poisToEdit.filter((poi) => {
        return poi.Id !== newPoi.Id;
      });
      poisToEdit.push(newPoi);
      setState({
        ...state,
        layerToggle: false,
        poisToEdit: poisToEdit,
        markerClickedToggle: false,
        currentTitle: "",
      });
    }
    if (!poiAdded && !poiEdited) {
      poisToEdit.push(newPoi);
      setState({
        ...state,
        layerToggle: false,
        poisToEdit: poisToEdit,
        markerClickedToggle: false,
        currentTitle: "",
      });
    }
  };

  const addPoisToMap = () => {
    let pois = data?.POI.filter((poi) => {
      return (
        (poi.floorId ===
          floorOverlays[state.currentFloorNumber].AndroidFloors[0].Id ||
          poi.floorId === null) &&
        poi.virtual === false
      );
    });
    let marker;
    if (pois) {
      pois.forEach((poi) => {
        const location = { lat: poi.Lat, lng: poi.Long };
        marker = new window.google.maps.Marker({
          position: location,
          //@ts-ignore
          title: poi.Description,
          zIndex: 3,
          id: poi.Id,
          draggable: true,
          label: {
            color: "black",
            fontWeight: "bold",
            //@ts-ignore
            text: poi.Description,
          },
          map: map,
        });
        markerList.push(marker);
        ((marker) => {
          window.google.maps.event.addListener(marker, "click", () => {
            markerClicked(marker);
          });
          window.google.maps.event.addListener(marker, "dragend", () => {
            markerDragged(marker);
          });
        })(marker);
      });
    }
  };

  const initMap = async (mapId: string) => {
    loc_center = new google.maps.LatLng(
      currentBuilding!.centerLat,
      currentBuilding!.centerLong
    );
    let url = "";
    if (!!getImageUrl) {
      url = await getImageUrl(
        "overlays",
        currentBuilding?.Id +
          "/" +
          floorOverlays[state.currentFloorNumber].Id +
          ".jpg"
      );
    }
    class DebugOverlay extends google.maps.OverlayView {
      //@ts-ignore
      map_?: google.maps.Map;
      opacity?: number;
      //@ts-ignore
      private bounds: google.maps.LatLngBounds;
      private image: string;
      private div?: HTMLElement;
      //@ts-ignore
      constructor(bounds: google.maps.LatLngBounds, image: any) {
        super();
        this.bounds = bounds;
        this.image = image;
      }

      onAdd() {
        this.div = document.createElement("div");
        this.div.style.borderStyle = "none";
        this.div.style.borderWidth = "0px";
        this.div.style.position = "absolute";
        this.div.style.visibility = "visible";
        var img = document.createElement("img");
        img.src = this.image;
        img.style.width = "100%";
        img.style.height = "100%";
        img.style.opacity = "1";
        img.style.position = "absolute";
        img.style.transform = "rotate(" + rot + "rad)";
        this.div.appendChild(img);
        //@ts-ignore
        var panes = this.getPanes();
        panes.overlayLayer.appendChild(this.div);
      }

      draw() {
        //@ts-ignore
        var overlayProjection = this.getProjection();
        var sw = overlayProjection.fromLatLngToDivPixel(
          this.bounds!.getSouthWest()
        );
        var ne = overlayProjection.fromLatLngToDivPixel(
          this.bounds!.getNorthEast()
        );
        var div = this.div;
        div!.style.left = sw.x + "px";
        div!.style.top = ne.y + "px";
        div!.style.width = ne.x - sw.x + "px";
        div!.style.height = sw.y - ne.y + "px";
        div!.style.transform = "rotate(" + rot + "deg)";
      }

      onRemove() {
        this?.div?.parentNode?.removeChild(this.div);
        delete this.div;
      }
    }
    const mapElement = document.getElementById(mapId);
    var mapOptions = {
      zoom: 18,
      center: loc_center,
      backgroundColor: "#051932",
      disableDefaultUI: true,
    };

    let initialize = () => {
      const customStyled = [
        {
          featureType: "all",
          elementType: "labels",
          stylers: [{ visibility: "off" }],
        },
      ];
      map.set("styles", customStyled);
      //@ts-ignore
      var newPointA = new window.google.maps.LatLng(
        CenterLat - k_diff,
        CenterLng - D_diff
      );
      //@ts-ignore
      var newPointB = new window.google.maps.LatLng(
        CenterLat + k_diff,
        CenterLng + D_diff
      );
      //@ts-ignore
      var bounds = new window.google.maps.LatLngBounds(newPointA, newPointB);
      var srcImage = url; //"https://res.cloudinary.com/dx8nclins/image/upload/v1569765645/buildings/fb10989e-942e-4142-8687-e7e903b03cef.png";

      overlay = new DebugOverlay(bounds, srcImage);
      overlay.setMap(map);
      //@ts-ignore
      map.addListener("click", function (e) {
        addMarker(e.latLng, map);
      });

      const floorChange = async (controlDiv: HTMLElement): Promise<any> => {
        var controlUI = document.createElement("div");
        controlUI.style.backgroundColor = "#fff";
        controlUI.style.marginRight = "5px";
        controlUI.style.border = "2px solid #fff";
        controlUI.style.borderRadius = "3px";
        controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
        controlUI.style.cursor = "pointer";
        controlUI.style.marginBottom = "22px";
        controlUI.style.textAlign = "center";
        controlDiv.appendChild(controlUI);

        var controlText = document.createElement("div");
        controlText.style.color = "rgb(25,25,25)";
        controlText.style.fontFamily = "Roboto,Arial,sans-serif";
        controlText.style.fontSize = "16px";
        controlText.style.lineHeight = "38px";
        controlText.style.paddingLeft = "5px";
        controlText.style.paddingRight = "5px";
        controlText.innerHTML = "Floor Up";
        controlUI.appendChild(controlText);

        controlUI.addEventListener("click", async () => {
          console.log("floor up");

          if (state.currentFloorNumber === floorOverlays.length - 1) {
            console.log("highest floor");
          } else {
            overlay.setMap(null);
            const newCurrentFloor = floorOverlays[state.currentFloorNumber + 1];
            const newCurrentFloorNumber = state.currentFloorNumber + 1;
            if (!!getImageUrl) {
              url = await getImageUrl(
                "overlays",
                currentBuilding?.Id +
                  "/" +
                newCurrentFloor.Id +
                  ".jpg"
              );
            }
            var srcImage = url;

            //@ts-ignore
            var newPointA = new window.google.maps.LatLng(
              CenterLat - newCurrentFloor.k_diff,
              CenterLng - newCurrentFloor.D_diff
            );
            //@ts-ignore
            var newPointB = new window.google.maps.LatLng(
              CenterLat + newCurrentFloor.k_diff,
              CenterLng + newCurrentFloor.D_diff
            );
            //@ts-ignore
            var bounds = new window.google.maps.LatLngBounds(
              newPointA,
              newPointB
            );
            rot = newCurrentFloor.Rot;
            overlay = new DebugOverlay(bounds, srcImage);
            overlay.setMap(map)
            /* eslint-disable */

            setState({ ...state, currentFloorNumber: newCurrentFloorNumber });
          }
        });

        var controlUI2 = document.createElement("div");
        controlUI2.style.backgroundColor = "#fff";
        controlUI2.style.marginRight = "5px";
        controlUI2.style.border = "2px solid #fff";
        controlUI2.style.borderRadius = "3px";
        controlUI2.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
        controlUI2.style.cursor = "pointer";
        controlUI2.style.marginBottom = "22px";
        controlUI2.style.textAlign = "center";
        controlDiv.appendChild(controlUI2);

        var controlText2 = document.createElement("div");
        controlText2.style.color = "rgb(25,25,25)";
        controlText2.style.fontFamily = "Roboto,Arial,sans-serif";
        controlText2.style.fontSize = "16px";
        controlText2.style.lineHeight = "38px";
        controlText2.style.paddingLeft = "5px";
        controlText2.style.paddingRight = "5px";
        controlText2.innerHTML = "Floor Down";
        controlUI2.appendChild(controlText2);

        controlUI2.addEventListener("click", async () => {
          console.log("floor down");

          if (state.currentFloorNumber === 0) {
            console.log("lowest floor");
          } else {
            overlay.setMap(null);
            const newCurrentFloor = floorOverlays[state.currentFloorNumber - 1];
            const newCurrentFloorNumber = state.currentFloorNumber + 1;
            if (!!getImageUrl) {
              url = await getImageUrl(
                "overlays",
                currentBuilding?.Id +
                  "/" +
                newCurrentFloor.Id +
                  ".jpg"
              );
            }
            var srcImage = url;
            //@ts-ignore
            var newPointA = new window.google.maps.LatLng(
              CenterLat - newCurrentFloor.k_diff,
              CenterLng - newCurrentFloor.D_diff
            );
            //@ts-ignore
            var newPointB = new window.google.maps.LatLng(
              CenterLat + newCurrentFloor.k_diff,
              CenterLng + newCurrentFloor.D_diff
            );
            //@ts-ignore
            var bounds = new window.google.maps.LatLngBounds(
              newPointA,
              newPointB
            );
            rot = newCurrentFloor.Rot;
            overlay = new DebugOverlay(bounds, srcImage);
            overlay.setMap(map)
            /* eslint-disable */

            setState({ ...state, currentFloorNumber: newCurrentFloorNumber });
          }
        });
      };
      let addMarker = (location: any, map: any) => {
        let idCount = state.idCount;
        idCount++;
        const marker = new window.google.maps.Marker({
          position: location,
          title: "New Point",
          zIndex: 3,
          //@ts-ignore
          id: idCount,
          draggable: true,
          label: {
            color: "black",
            fontWeight: "bold",
            text: "test",
          },
          map: map,
        });

        markerList.push(marker);
        ((marker) => {
          window.google.maps.event.addListener(marker, "click", () => {
            markerClicked(marker);
          });
          window.google.maps.event.addListener(marker, "dragend", () => {
            markerDragged(marker);
          });
        })(marker);
        setState({
          ...state,
          markerListPosition: markerList.length - 1,
          layerToggle: true,
          lastPoint: location,
          idCount: idCount,
          markerClickedToggle: false,
        });
      };

      var floorControlDiv = document.createElement("div");
      floorChange(floorControlDiv);
      //@ts-ignore
      map.controls[window.google.maps.ControlPosition.RIGHT_CENTER].push(
        floorControlDiv
      );
      addPoisToMap();
    };

    if (!!mapElement) {
      //@ts-ignore
      map = new google.maps.Map(mapElement, mapOptions);
      initialize();
    } else {
      console.log("no map element");
    }
  };

  useEffect(() => {
    if (!!data) {
      let googleMapPromise = getGoogleMaps();
      CenterLat = currentBuilding?.centerLat;
      CenterLng = currentBuilding?.centerLong;
      k_diff = floorOverlays[state.currentFloorNumber].k_diff;
      D_diff = floorOverlays[state.currentFloorNumber].D_diff;
      rot = floorOverlays[state.currentFloorNumber].Rot;
      if (!window.google) {
        Promise.all([googleMapPromise]).then((values) => {
          initMap("poiMap");
        });
      } else {
        initMap("poiMap");
      }
    }
  }, [data]);

  useEffect(() => {
    props.poiTypes?.forEach((poiType) => {
      if (poiType.title === "Patrol Point") {
        setState({ ...state, type: poiType.id });
      }
    });
  }, []);

  if (loading) {
    return <LinearProgress />;
  } else if (error) {
    return <div>{error.message}</div>;
  } else {
    const styles = {
      container: {
        height: "70vh",
        width: "100%",
        //display: 'flex',
        //flexDirection: 'column',
      },
    };
    const typeInputs = props.poiTypes?.map((poiType) => {
      return {
        value: poiType.id,
        label: poiType.title,
      };
    });
    const modalInputs: ConfigInput[] = [
      {
        title: "Select POI Type",
        type: "select",
        onChange: handlePoiTypeChange,
        xs: 12,
        sm: 6,
        id: "poiType",
        placeholder: "select POI type",
        options: typeInputs,
        value: state.type,
      },
    ];
    return (
      <MapContainer>
        {/* <ControlContainer>
          <Typography>Click to add POI or drag to move POI</Typography>
          <Button>Save and Upload</Button>
        </ControlContainer> */}
        <div id="poiMap" style={styles.container} />
        <StandardModal
          open={state.layerToggle}
          title="Add/Edit Point of Interest"
          onCancel={() => {}}
          onSubmit={() => {}}
        >
          <ConfigForm inputs={modalInputs}></ConfigForm>
        </StandardModal>
      </MapContainer>
    );
  }
}
